import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getClubName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.clubs.club_name'],
);

export const getClubCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.clubs.club_code'],
);

export const getClubStartDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.clubs.club_start_date'],
);

export const getClubEndDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.clubs.club_end_date'],
);

export const getName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.clubname'],
);

export const getCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.clubcode'],
);

export const getStartDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.startdate'],
);

export const getEndDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.enddate'],
);

export const getShowInactiveClubs = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.showinactive'],
);

export const getDefaultDiscountType = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.defaultdiscounttype'],
);

export const getDefaultDiscountAmount = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.defaultdiscountamount'],
);

export const getDefaultDiscountPercentage = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.defaultdiscountpercentage'],
);

export const getNewClubHeader = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.createnewclub'],
);

export const getEditClubHeader = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.editclub'],
);

export const getDeactivateClub = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.clubs.deactivate'],
);

export const getSyncClubMembers = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.clubs.syncclubmembers'],
);

export const getSyncClubMembersHelper = createSelector(
  getLiteralsState,
  ({ literals }) => literals['help.club.syncclubmembers'],
);

export const getCreateClubSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.create.success'],
);

export const getUpdateClubSuccess = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.update.success'],
);

export const getDeleteClubConfirm = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.club.youareabouttodeactivateclub'],
);
